module.exports = __webpack_public_path__ + "static/media/High Stepping Jessy.769d3757.jpg";